import { FONT_FAMILY, FONT_SIZE, THEME_COLORS } from "../../common/themes";
import React, { Component } from "react";
import { SingleSelectV3 } from "../../common/component";
import SingleSelectNestedDropDown from "../../common/component/SingleSelectNestedDropDown";
import { StyleProp, StyleSheet, TouchableOpacity, View, ViewProps } from "react-native";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ModalV3 from "../../common/component/ModalV3";
import Notification from "../../component/Header/NotificationModal";
import NotificationIcon from "../../assets/icons/NotificationIcon";
import ProfileInfo from "./ProfileInfo";
import SignoutModal from "./SignoutModal";
// import { Image } from "react-native-elements";
import Text from "../../common/component/CustomTextComponent";
import { getAvailableScreens } from "../Login/Auth";
import { setCookie } from "../../common";

interface IHeaderProps {
  navigation: any;
  headerStyle?: StyleProp<ViewProps>;
  onLogoutButtonPress: () => void;
  userMetaData?: any;
}

interface IHeaderTabProps {
  onPress: () => void;
  isActive: boolean;
  text: string;
}

const HeaderTab = (props: IHeaderTabProps) => {
  const { onPress, isActive, text } = props;
  return (
    <TouchableOpacity style={[headerStyles.tab]} onPress={onPress}>
      <Text
        type_of_six={"one_six"}
        fontSize={"x-small"}
        style={[headerStyles.tabText, isActive ? { color: THEME_COLORS.red } : null]}
      >
        {text}
      </Text>
    </TouchableOpacity>
  );
};

export default class Header extends Component<IHeaderProps> {
  state = {
    isUserLoggedIn: false,
    isUserProfileDropdownVisible: false,
    selectedWSConfig: null,
    anchorEl: null,
    openSignout: false,
  };

  constructor(props) {
    super(props);
    const { navigation, userMetaData } = this.props;

    this.state.isUserLoggedIn = props.isUserLoggedIn;
    this.workshopConfigs = JSON.parse(localStorage.getItem("workshopConfigs")) || [];
    this.currentWSConfig = JSON.parse(localStorage.getItem("userMetaData")) || {};
    this.state.selectedWSConfig = this.currentWSConfig;

    const navParams = navigation.state.params;

    if (!navParams?.label) {
      const screens = !!userMetaData ? getAvailableScreens(userMetaData) : [];
      const currentScreen = screens.find((obj) => obj.screen === navigation.state.routeName);
      if (!currentScreen?.virtual) navigation.setParams({ label: currentScreen?.label });
    }
  }

  componentDidMount() {
    this.setState({ selectedWSConfig: this.currentWSConfig });
    !!this.currentWSConfig?.workshop?.displayName?.replace(/ /g, "_") &&
      setCookie("workshop", this.currentWSConfig?.workshop?.displayName?.replace(/ /g, "_"));
  }

  onWorkshopChange = (wsConfigId) => {
    if (this.state.selectedWSConfig?.workshop?.id !== wsConfigId) {
      const wsConfig = this.workshopConfigs?.find((wsConfig) => wsConfig?.workshop?.id == wsConfigId);
      !!wsConfig?.workshop?.displayName?.replace(/ /g, "_") &&
        setCookie("workshop", wsConfig?.workshop?.displayName?.replace(/ /g, "_"));
      this.setState({ selectedWSConfig: wsConfig }, () => {
        this.onSwitchWorkshop();
      });
    }
  };

  onSwitchWorkshop = () => {
    const { selectedWSConfig } = this.state;
    if (!selectedWSConfig) return;
    localStorage.setItem("userMetaData", JSON.stringify(selectedWSConfig));
    localStorage.setItem("workshopId", selectedWSConfig.workshop.id);
    if (selectedWSConfig.isNewFlowVisible) {
      localStorage.setItem("user_flow", "NewFlow");
    } else {
      localStorage.setItem("user_flow", "OldFlow");
    }

    if (this.props.navigation?.state?.params?.cancelable) {
      window.history.go(-1);
    } else {
      window.location.reload();
    }
    // navigation.navigate("Login", { ...navParams, reRouteName: navState.routeName });
  };

  render() {
    const { navigation, onLogoutButtonPress, userMetaData } = this.props;
    const navState = navigation.state;
    const navParams = navState.params;
    const routeName = navState.routeName;
    const { isUserLoggedIn, selectedWSConfig, anchorEl, openSignout } = this.state;
    const userFullName = !!userMetaData ? userMetaData.fullName : "";
    const screens = !!userMetaData ? getAvailableScreens(userMetaData) : [];
    const flowName = localStorage.getItem("user_flow");
    const isNewFlow = flowName === "NewFlow";
    const { workshopConfigs } = this;
    const isSparePartsScreenActive = routeName === "SparePartsScreen";
    const propsHeaderStyle = this.props.headerStyle
      ? this.props.headerStyle
      : { height: isSparePartsScreenActive ? 80 : 120 };
    const header = navParams?.headerTitle ?? navParams?.label;

    return (
      <>
        <View
          style={[
            {
              flexDirection: "row",
              alignItems: "center",
              zIndex: 999999,
              backgroundColor: THEME_COLORS.white,
            },
            propsHeaderStyle,
          ]}
        >
          <View
            style={{
              flex: 1,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {isUserLoggedIn ? (
              <>
                <View
                  style={{
                    justifyContent: "center",
                    flex: 1,
                    // marginTop: 5,
                    marginLeft: 20,
                  }}
                >
                  {header && (
                    <Text style={[headerStyles.labelTxt, navParams?.labelSt ? JSON.parse(navParams?.labelSt) : null]}>
                      {header || ""}
                    </Text>
                  )}

                  {!isSparePartsScreenActive && workshopConfigs.length > 0 && (
                    <View style={{ width: 240, marginTop: 8, marginLeft: 8 }}>
                      <SingleSelectNestedDropDown
                        disable={false}
                        enableOutsideClickToDismissDropDown={true}
                        styles={{
                          borderColor: "#DFDFDF",
                        }}
                        hasSearch={true}
                        searchPlaceholder="Search workshop"
                        borderWidth={1}
                        paddingHorizonal={16}
                        paddingVertical={12}
                        dropDownWidth={240}
                        positionX="middle"
                        positionY="bottom"
                        direction="down"
                        defaultTitle="Select workshop"
                        data={
                          workshopConfigs?.map((ws) => ({
                            id: ws?.workshop?.id?.toString(),
                            name: ws?.workshop?.displayName ?? "",
                            isDisable: false,
                            children: null,
                          })) ?? []
                        }
                        selectedId={selectedWSConfig?.workshop?.id?.toString() ?? ""}
                        selectedItem={selectedWSConfig?.workshop?.displayName ?? ""}
                        canClearFilter={false}
                        onItemPress={(val) => {
                          this.onWorkshopChange(val?.id);
                        }}
                        containerFontSize={13}
                        containerColor={THEME_COLORS.white}
                        containerFontColor={
                          selectedWSConfig?.workshop?.id ? THEME_COLORS.purple : THEME_COLORS.grey0
                        }
                        onClearFilter={() => {}}
                      />
                    </View>
                  )}
                </View>

                <View style={{ flexDirection: "row" }}>
                  {!isSparePartsScreenActive && selectedWSConfig.isNewFlowVisible ? (
                    <SingleSelectV3
                      options={["OldFlow", "NewFlow"]}
                      value={flowName}
                      setValue={(value) => {
                        localStorage.setItem("user_flow", value);
                        window.location.reload();
                      }}
                      style={{ fontSize: 13, marginTop: "6px" }}
                      clearIconVisible={false}
                    />
                  ) : null}

                  <View
                    style={{
                      marginRight: 40,
                      position: "relative",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    {/* <TouchableOpacity
                      onPress={() => {
                        this.setState({ visible: true });

                        console.log(this.state.visible);
                      }}
                    >
                      <NotificationIcon
                        style={{
                          color: THEME_COLORS.purple,
                          fontSize: 30,
                          marginLeft: '1rem',
                          marginTop: '0.5rem',
                        }}
                      />
                    </TouchableOpacity> */}

                    <AccountCircleOutlinedIcon
                      aria-describedby="profile-info"
                      style={{ color: THEME_COLORS.purple, fontSize: 30 }}
                      onClick={(event) => this.setState({ anchorEl: event.currentTarget })}
                    />
                    <ProfileInfo
                      anchorEl={anchorEl}
                      setAnchorEl={(arg) => this.setState({ anchorEl: arg })}
                      userName={userFullName}
                      userType={userMetaData?.userType}
                      onLogout={() => this.setState({ openSignout: true })}
                    />
                  </View>
                </View>
              </>
            ) : null}
          </View>
        </View>

        <ModalV3
          visible={this.state.visible}
          header={"Notifications"}
          subheader={"12 new notifications"}
          onClose={() => this.setState({ visible: false })}
        >
          <Notification />
        </ModalV3>

        <SignoutModal
          open={openSignout}
          setOpen={(arg) => this.setState({ openSignout: arg })}
          onConfirm={onLogoutButtonPress}
        />
      </>
    );
  }
}

const headerStyles = StyleSheet.create({
  tab: { marginHorizontal: "0.5rem" },
  logo: { marginHorizontal: "1rem" },
  activePage: { color: "#777", marginHorizontal: 5 },
  page: { color: "#000", marginHorizontal: 5 },
  headText: {
    fontSize: FONT_SIZE.logoFontSize,
    color: THEME_COLORS.primary,
    fontWeight: "bold",
    fontFamily: FONT_FAMILY.primary,
  },
  tabText: {
    fontSize: FONT_SIZE.s2,
    color: THEME_COLORS.primary,
    fontFamily: FONT_FAMILY.four,
  },
  tabSubText: {
    fontSize: 19,
    color: THEME_COLORS.primary,
    fontWeight: "bold",
    fontFamily: FONT_FAMILY.primary,
  },
  userIcon: {
    fontSize: "36px",
    color: THEME_COLORS.primary,
  },
  labelTxt: {
    fontSize: 30,
    color: THEME_COLORS.primary,
    fontFamily: FONT_FAMILY.boldV3,
    marginLeft: 8,
  },
});
